import { createContext, Dispatch } from 'react';
import {
  ChannelTypeUnitsAndPercentageModel,
  ChannelGroupModel,
  DataOptionsType,
  GraphUnitsModel,
  IntervalOptionsType,
  RefreshButtonModel,
} from '@shared/models';

export const GraphReducerDefaultValues = {
  interval: IntervalOptionsType.Auto,
  dataType: DataOptionsType.Primary,
  units: [] as GraphUnitsModel[],
  showAlarmBoundariesAsPercentage: null as boolean,
  channelTypeUnitsAndPercentage: {
    channelTypeUnitOptions: [],
    canShowPercentage: false,
  } as ChannelTypeUnitsAndPercentageModel,
  channelGroups: [] as ChannelGroupModel[],
};

export enum GraphActionType {
  SetInterval = 'SetInterval',
  SetDataType = 'SetDataType',
  SetUnits = 'SetUnits',
  SetChannelTypeUnitsAndPercentage = 'SetChannelTypeUnitsAndPercentage',
  SetShowAsPercentage = 'SetShowAlarmBoundariesAsPercentage',
  SetChannelGroups = 'SetChannelGroups',
}

type State = typeof GraphReducerDefaultValues;
type Action = {
  type: GraphActionType;
  payload:
    | boolean
    | IntervalOptionsType
    | DataOptionsType
    | GraphUnitsModel[]
    | ChannelTypeUnitsAndPercentageModel
    | ChannelGroupModel[]
    | RefreshButtonModel;
};

export const graphReducer = (state: State, action: Action): State => {
  const { type, payload } = action;
  switch (type) {
    case GraphActionType.SetInterval:
      return { ...state, interval: payload as IntervalOptionsType };
    case GraphActionType.SetDataType:
      return { ...state, dataType: payload as DataOptionsType };
    case GraphActionType.SetUnits:
      return { ...state, units: payload as GraphUnitsModel[] };
    case GraphActionType.SetChannelGroups:
      return { ...state, channelGroups: payload as ChannelGroupModel[] };
    case GraphActionType.SetShowAsPercentage:
      return { ...state, showAlarmBoundariesAsPercentage: payload as boolean };
    case GraphActionType.SetChannelTypeUnitsAndPercentage:
      return {
        ...state,
        channelTypeUnitsAndPercentage: payload as ChannelTypeUnitsAndPercentageModel,
      };
    default:
      return state;
  }
};

export const GraphContext = createContext<{
  state?: State;
  dispatch?: Dispatch<Action>;
}>({});
